import { memo } from 'react';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormPhoneOrEmailField } from './KioskFormPhoneOrEmailField/KioskFormPhoneOrEmailField';
import { WebFormPhoneOrEmailField } from './WebFormPhoneOrEmailField/WebFormPhoneOrEmailField';
import { FormPhoneOrEmailFieldProps } from './FormPhoneOrEmailField.types';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';

const FormPhoneOrEmailField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required = false,
    autoFocus,
    keyboardLayout = KeyboardLayouts.Email,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = true,
    tabFocusRefContext,
    initiallyMasked = false,
    onChangeCallback,
}: FormPhoneOrEmailFieldProps) => {
    return isElectron() ? (
        <KioskFormPhoneOrEmailField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            initiallyMasked={initiallyMasked}
            onChangeCallback={onChangeCallback}
        />
    ) : (
        <WebFormPhoneOrEmailField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            initiallyMasked={initiallyMasked}
        />
    );
});

export default FormPhoneOrEmailField;